<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper>
        <mat-step *ngIf="showFirstStep" [completed]="!!selectedUsersList.length">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</ng-template>

            <ng-container *ngIf="selectedUsersList.length">
                <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                <mat-chip-set class="chip-list wrap">
                    <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(user)" *ngFor="let user of selectedUsersList">
                        {{ user.fullName }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #firstNameRow class="text-truncate font-semibold">
                                {{ user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #lastNameRow class="text-truncate font-semibold">
                                {{ user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember && !user.selected"></app-flat-button>
                                <p *ngIf="user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="course-offering-participants.add-course-offering-bookings-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.EXECUTIONS' | translate }}</ng-template>

            <mat-form-field class="w-100-p">
                <mat-label>{{ 'GENERAL.LABEL.EXECUTION' | translate }}</mat-label>
                <mat-select [formControl]="selectedExecution">
                    <mat-option *ngFor="let execution of executions" [value]="execution" [disabled]="!isExecutionSelectable(execution)">
                        <div fxFlex="row" fxLayoutAlign="start space-between">
                            <div fxFlex="column" fxLayoutAlign="start center">
                                <span>
                                    {{ execution.name }}
                                </span>
                                <span>&nbsp;</span>
                                <span class="text-gray-400 text-xs">
                                    ({{
                                        execution.version
                                            ? execution.version
                                            : execution.startDate
                                            ? (execution.startDate | date: 'shortDate') + ' - ' + (execution.endDate | date: 'shortDate')
                                            : '-'
                                    }})
                                </span>
                            </div>
                            <div *ngIf="execution.isDefault">
                                <span class="bg-primary-50 rounded-full px-16 py-8 mr-12 text-sm text-primary-600 font-medium">
                                    {{ 'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.DEFAULT_EXECUTION' | translate }}
                                </span>
                            </div>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-step>

        <mat-step [completed]="false">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.NOTIFICATION' | translate }}</ng-template>

            <mat-checkbox [(ngModel)]="notifyMembers">{{ 'GENERAL.BUTTON.SEND_NOTIFICATION' | translate }}</mat-checkbox>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.NEXT'"
        class="mr-8"
        [disabled]="showFirstStep && stepper?.selectedIndex === 0 ? !selectedUsersList.length : !canGoToNotificationStep"
        (onClick)="goForward(stepper)"
        *ngIf="shouldShowNextButton"
    ></app-flat-button>

    <app-flat-button
        [label]="
            selectedUsersList.length ? ('GENERAL.BUTTON.BOOK_PARTICIPANTS' | translate: { participantsCount: selectedUsersList.length }) : 'GENERAL.BUTTON.BOOK_ALL_PARTICIPANTS'
        "
        [disabled]="!selectedExecution.value"
        (onClick)="saveSelected()"
        *ngIf="isLastStep"
    ></app-flat-button>
</div>
